<template>
  <main
    class="app-modal-content"
    :class="{ padding, 'side-padding': sidePadding }"
  >
    <slot />
  </main>
</template>

<script>
export default {
  name: 'AppModalContent',

  props: {
    sidePadding: {
      type: Boolean,
      default: false,
    },

    padding: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;

.app-modal-content {
  min-height: fit-content;
  overflow-y: auto;

  &.padding {
    padding: $defaultPadding;
  }

  &.side-padding {
    padding-left: $defaultPadding;
    padding-right: $defaultPadding;
  }
}
</style>
